import './CircularBadge.css';

import React from 'react';

const CircularBadge: React.FC = () => {
  const text = 'Made by cheer coaches, for cheer coaches. ';
  const chars = text.split('');
  const angleStep = 360 / chars.length;
  const mapleLeaf = `${process.env.PUBLIC_URL}/images/Maple_Leaf.svg`;

  return (
    <div className="circular-badge" aria-label={`Made by cheer coaches, for cheer coaches.`}>
      <div className="circular-badge-spinner">
        <div className="circular-badge-text">
          {chars.map((char, index) => {
            const angle = index * angleStep;
            return (
              <span
                key={index}
                className="circular-badge-char"
                style={{
                  transform: `rotate(${angle}deg)`,
                }}
              >
                {char}
              </span>
            );
          })}
        </div>
      </div>
      <div className="circular-badge-center">
        <img src={mapleLeaf} alt="Canadian Maple Leaf" className="maple-leaf" />
      </div>
    </div>
  );
};

export default CircularBadge;
